const BASE = process.env.REACT_APP_MOBILE_ENDPOINT_BASE;


async function http(path, body, idToken) {
  const resp = await fetch(`${BASE}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
    },
    body: JSON.stringify(body),
  });
  if (!resp.ok) throw new Error(`HTTP ${resp.status} – ${await resp.text()}`);
  return resp.json();
}

export function upsertMobileConfigUser(uid, data, idToken) {
  return http("/configUser", { uid, data }, idToken);
}

export function updateMobileUserRole({ uid, role, roleStatus }, idToken) {
  return http("/userRole/update", { uid, role, roleStatus }, idToken);
}

export function deleteMobileMeeting(uid, mobileMeetingId, idToken) {
  return http("/meetings/delete", { uid, id: mobileMeetingId }, idToken);
}

export function createMobileMeeting(
  { uid, title, startAtISO, email },
  idToken
) {
  return http("/meetings", { uid, title, startAt: startAtISO, email }, idToken);
}

export function addMobileVideoLink(
  { title, url, category, order, storagePath, workbookUrl },
  idToken
) {
  return http(
    "/videoLinks/add",
    { title, url, category, order, storagePath, workbookUrl },
    idToken
  );
}

export function deleteMobileVideoLink(mobileId, idToken) {
  return http("/videoLinks/delete", { id: mobileId }, idToken);
}

export function updateMobileVideoOrder(id, order, idToken) {
  return http("/videoLinks/updateOrder", { id, order }, idToken);
}

// --- AUDIO ---
export function addMobileAudioLink(
  { title, description, category, url, storagePath, order },
  idToken
) {
  return http(
    "/audio/add",
    { title, description, category, url, storagePath, order },
    idToken
  );
}

export function deleteMobileAudioLink(id, idToken) {
  return http("/audio/delete", { id }, idToken);
}

export function updateMobileAudioOrder(id, order, idToken) {
  return http("/audio/updateOrder", { id, order }, idToken);
}

// --- REMPLACEMENT (utilise BASE au lieu de API_BASE) ---
export async function updateMobileVideoLink(id, payload, idToken) {
  const r = await fetch(`${BASE}/videos/${id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(payload),
  });
  if (!r.ok) throw new Error(`updateMobileVideoLink failed`);
  return r.json();
}

export async function updateMobileAudioLink(id, payload, idToken) {
  const r = await fetch(`${BASE}/audios/${id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(payload),
  });
  if (!r.ok) throw new Error(`updateMobileAudioLink failed`);
  return r.json();
}
